customElements.get("product-modal") ||
  customElements.define(
    "product-modal",
    class extends ModalDialog {
      constructor() {
        super();
        this.currentMediaId = null;
        this.hasModalHistoryState = false;
        this.handlingPopStateClose = false;
        this.prevButton = this.querySelector("[data-product-modal-prev]");
        this.nextButton = this.querySelector("[data-product-modal-next]");
        this.thumbButtons = Array.from(
          this.querySelectorAll("[data-product-modal-thumb]")
        );
        this.handlePopState = this.handlePopState.bind(this);
        window.addEventListener("popstate", this.handlePopState);

        if (this.prevButton) {
          this.prevButton.addEventListener("click", () => this.navigate(-1));
        }
        if (this.nextButton) {
          this.nextButton.addEventListener("click", () => this.navigate(1));
        }
        if (this.thumbButtons.length) {
          this.thumbButtons.forEach((button) => {
            button.addEventListener("click", () => {
              this.showActiveMedia(button.getAttribute("data-media-id"));
            });
          });
        }
      }

      hide() {
        const wasOpen = this.hasAttribute("open");
        super.hide();
        if (!wasOpen) return;

        if (this.hasModalHistoryState && !this.handlingPopStateClose) {
          history.back();
        }
        this.hasModalHistoryState = false;
      }

      show(opener) {
        super.show(opener);
        const mediaId = opener?.getAttribute("data-media-id");
        this.showActiveMedia(mediaId);

        if (!this.hasModalHistoryState) {
          history.pushState(
            { ...history.state, productMediaModalOpen: true },
            ""
          );
          this.hasModalHistoryState = true;
        }
      }

      handlePopState() {
        if (!this.hasAttribute("open")) return;
        this.handlingPopStateClose = true;
        this.hide();
        this.handlingPopStateClose = false;
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll("[data-media-id]")).filter(
          (item) => item.closest(".product-media-modal__content")
        );
      }

      navigate(direction) {
        const items = this.getMediaItems();
        if (items.length < 2) return;

        const currentIndex = items.findIndex(
          (item) => item.getAttribute("data-media-id") === this.currentMediaId
        );
        const baseIndex = currentIndex === -1 ? 0 : currentIndex;
        const nextIndex =
          (baseIndex + direction + items.length) % items.length;
        this.showActiveMedia(items[nextIndex].getAttribute("data-media-id"));
      }

      showActiveMedia(targetMediaId) {
        const items = this.getMediaItems();
        if (!items.length) return;

        const fallbackId =
          targetMediaId ||
          this.openedBy?.getAttribute("data-media-id") ||
          items[0].getAttribute("data-media-id");

        const targetItem =
          items.find(
            (item) => item.getAttribute("data-media-id") === fallbackId
          ) || items[0];

        items.forEach((item) => item.classList.remove("active"));
        targetItem.classList.add("active");
        this.currentMediaId = targetItem.getAttribute("data-media-id");

        this.updateThumbState();
        targetItem.scrollIntoView({ block: "nearest", inline: "center" });

        const template = targetItem.querySelector("template");
        const templateContent = template ? template.content : null;
        if (
          targetItem.nodeName === "DEFERRED-MEDIA" &&
          templateContent &&
          templateContent.querySelector(".js-youtube")
        ) {
          targetItem.loadContent();
        }
      }

      updateThumbState() {
        if (!this.thumbButtons.length) return;

        this.thumbButtons.forEach((thumb) => {
          const isActive =
            thumb.getAttribute("data-media-id") === this.currentMediaId;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-current", isActive ? "true" : "false");
        });
      }
    }
  );
